import axios, {AxiosError} from "axios";
import { API_URL } from "../constant";
import { RegisterResponse } from "../constant";
  
export async function DeleteAllFilings(): Promise<RegisterResponse> {
    const token = localStorage.getItem("token")
        
    const config = {
        headers: {
          Authorization: `Bearer ${token}`, // Bearer token
        },
        validateStatus: (status: number) => {
            return status >= 200 && status < 500
        }
      };

    const requestdata = {}
    try {
        const response = await axios.post(
          `${API_URL}api/filing/remove_all`,
          requestdata,
          config,
        );
    
        if (response.status === 204)
        {
            return { success: true, msg: "Successfully deleted all entries"};
        }
        else if (response.status === 422)
        {
            return { success: false, msg: "Validation Error" };
        }
        else if (response.status === 400)
        {
            return { success: false, msg: response.data.detail || "Validation Error" }; 
        }
        else{
            return { success: false, msg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, msg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, msg: "No response received from server" };
        } else {
            return { success: false, msg: `Error:, ${error.message}` };
        }
    }
}